// CMS text sizes need to be mapped to the headline sizes from the ui-components
export const getHeadlineSize = (size)=>size && [
        'l',
        'm',
        's'
    ].includes(size) ? size.toUpperCase() : 'M';

//# sourceMappingURL=text.js.map